module.exports = __webpack_public_path__ + "static/img/身份证反面示例.3a7494e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/身份证反面示例.jpg
// module id = yIs3
// module chunks = 1